import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import autoTable from 'jspdf-autotable';
import { chown } from 'fs';
import jsPDF, { jsPDFOptions } from 'jspdf';
import { ToastrComponentlessModule, ToastrService } from 'ngx-toastr';
import { ReportService } from '../services/report.service';
import { Interface } from 'readline';

interface bodyTableGroups {
  name: string;
  qtd_members: string;
  qtd_present: string;
  visitors: string;
}
@Component({
  selector: 'app-frequency-report',
  templateUrl: './frequency-report.component.html',
  styleUrls: ['./frequency-report.component.css'],
})
export class FrequencyReportComponent implements OnInit {
  heightPerRowInTable = 7.625;
  headerPageSize = 15.4;

  groups: Array<{ id: number; checked: boolean; name: string }> = [];
  form = new FormGroup({});
  constructor(private reportService: ReportService, private toast: ToastrService) {
    this.form = new FormGroup({
      startDate: new FormControl('', Validators.required),
      endDate: new FormControl('', Validators.required),
    });
  }

  ngOnInit(): void {
    //this.getGroupListToReport();
    const jsoptions: jsPDFOptions = {
      orientation: 'landscape',
      format: 'A4',
    };
  }

  submit() {
    this.reportService.getReport(this.form.value).then((res) => this.makePDF(res));
  }

  formateData(data: string): string {
    if (!this.form.valid) {
      return;
    }
    return data.split(' ')[0].split('-').reverse().join('/');
  }

  makePDF(data) {
    const doc: jsPDF = new jsPDF();
    data.map((study) => {
      autoTable(doc, {
        columnStyles: { 0: { halign: 'left', cellWidth: 210 }, 1: { halign: 'center', cellWidth: 30 } },
        columns: [
          {
            header: 'Tema de estudo ' + study.theme + ' data: ' + this.formateData(study.created_at),
            dataKey: 'group',
          },
        ],
        headStyles: {
          textColor: '#000',
          fillColor: '#fff',
          halign: 'center',
        },
        styles: {
          fillColor: '#fff',
        },
      });

      const body: any = [];

      study.frequencies.map((frequency) => {
        const percent: string = (
          (parseInt(frequency['__meta__'].presents) / parseInt(frequency['__meta__'].total)) *
          100
        )
          .toFixed(2)
          .toString();
        const members = `${frequency['__meta__'].presents} / ${frequency['__meta__'].total}`;
        let visitors;
        if (frequency.visitors == '' || frequency.visitors == null || frequency.length == 0) {
          visitors = 0;
        } else {
          visitors = frequency.visitors?.split(';').length;
        }
        const row: bodyTableGroups = {
          name: frequency.group.name,
          qtd_members: members,
          qtd_present: percent + '%',
          visitors: visitors,
        };
        body.push(row);
      });
      autoTable(doc, {
        columnStyles: { 0: { halign: 'left', cellWidth: 100 }, 1: { halign: 'center', cellWidth: 30 } },
        headStyles: {
          textColor: '#000',
          fillColor: '#FFF',
          lineColor: '#000',
          lineWidth: { bottom: 0.5 },
        },
        columns: [
          { header: 'Célula', dataKey: 'name' },
          { header: 'visitantes', dataKey: 'visitors' },
          { header: 'presença', dataKey: 'qtd_members' },
          { header: '(%)', dataKey: 'qtd_present' },
        ],
        body: body,
        bodyStyles: {
          lineColor: '#000',
          lineWidth: {
            bottom: 0.1,
          },
        },
        alternateRowStyles: {
          fillColor: '#FFF',
          lineWidth: {
            bottom: 0.1,
          },
        },
      });
    });

    /*    autoTable(doc, {
      columnStyles: { 0: { halign: 'left', cellWidth: 100 }, 1: { halign: 'center', cellWidth: 30 } },
      columns: [
        { header: 'Célula', dataKey: 'group' },
        { header: 'membros(QTD)', dataKey: 'dd' },
        { header: 'presença %', dataKey: 'qtd_members' },
      ],
      body: [
        { group: 'Os Escolhidos', dd: 1 },
        { group: 'Os Escolhidos', dd: 1 },
        { group: 'Os Escolhidos', dd: 1 },
        { group: 'Os Escolhidos', dd: 1 },
        { group: 'Os Escolhidos', dd: 1 },
        { group: 'Os Escolhidos', dd: 1 },
        { group: 'Os Escolhidos', dd: 1 },
        { group: 'Os Escolhidos', dd: 1 },
        { group: 'Os Escolhidos', dd: 1 },
      ],
    });

    autoTable(doc, {
      columnStyles: { 0: { halign: 'left', cellWidth: 210 }, 1: { halign: 'center', cellWidth: 30 } },
      columns: [{ header: 'Tema de estudo', dataKey: 'group' }],
      headStyles: {
        textColor: '#000',
        fillColor: '#ccc',
        halign: 'center',
      },
    });
 */
    /* doc.text('---', 210 / 2, 297 - 273, { align: 'center' }, null); //24
    doc.text('---', 210 / 2, 297 - 266, { align: 'center' }, null); //31
    doc.text('-----------------', 210 / 2, 297 - 266.5, { align: 'center' }, null); // 16 headerSize
    doc.text('-----------------', 210 / 2, 297 - 205.5, { align: 'center' }, null); // 16 headerSize
    doc.text('--HEADER---', 210 / 2, this.heightPerRowInTable * 10 + this.headerPageSize, { align: 'center' }, null); // 16 headerSize */

    const pageCount = doc.getNumberOfPages();

    // For each page, print the page number and the total pages

    for (var i = 1; i <= pageCount; i++) {
      // Go to page i
      doc.addImage('../../../assets/icons/fogo-e-peixe.png', 'png', 13, 2.5, 10, 10);
      doc.setPage(i);

      doc.setFontSize(10);
      doc.setFont(undefined, 'bold');

      doc.text('Relatório de frequência das Células', 210 / 2, 297 - 290, { align: 'center' }, null);

      doc.setFont(undefined, 'normal');
      doc.text(
        `Dados são de ${this.formateData(this.form.value.startDate)} a ${this.formateData(this.form.value.endDate)}`,
        210 / 2,
        297 - 285,
        { align: 'center' },
        null
      );
      doc.text('Page ' + String(i) + ' of ' + String(pageCount), 210 / 2, 297 - 10, { align: 'center' }, null);
    }

    doc.save('relatório.pdf');
    /*  const ids = [];
    this.groups.map((group) => {
      if (group.checked) {
        ids.push(group.id);
      }
    });
    this.reportService.getReport({ ids }).then((res) => {
      console.log(res);
    }); */
  }
}
